export const BASE_CACHE_PREFIX = "@sortelec_cache"

// Modo manutenção: quando true, todos os usuários veem a tela de manutenção
// e nenhuma rota/loader/chamada de backend é executada. Voltar para false ao reabrir.
export const MAINTENANCE_MODE = true

// Suporte via WhatsApp (85 9848-0191) — usado no CTA de bloqueio de saque
export const SUPPORT_WHATSAPP_URL = "https://wa.me/5585998480191"


export enum CACHE_KEYS {
  TOKEN = `${BASE_CACHE_PREFIX}_token_auth`,
  AUDIO_ENABLED = `${BASE_CACHE_PREFIX}_audio_enabled`,
  PLAYER_VELOCITY = `${BASE_CACHE_PREFIX}_player_velocity`
}